import { c as _c } from "react/compiler-runtime";
import React from 'react';
const AffiliateSettingsSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[66px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-background-secondary flex h-fit w-full flex-col gap-5 overflow-x-hidden rounded-md"><div className="flex animate-pulse flex-col gap-7 px-5 pb-5 lg:gap-10 ">{t0}<div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[66px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default AffiliateSettingsSkeleton;